/* eslint-disable class-methods-use-this */
import { each, includes, map } from 'lodash';
import ApplicationController from '../application_controller';
import { isBlank } from '../../../../libs/strings';

/* global $, Cifra */
export default class extends ApplicationController {
  connect() {
    this.conectarFiltroEtiquetas();
    this.refrescarActivas();
    this.cargarBotonEtiquetar();
  }

  conectarFiltroEtiquetas() {
    const $mensajes = $('#mensajes');
    // Hay que hacer esto porque el controlador de mensajes es una puta mierda
    // y para entrar a veces entra por index y otras por mensajes/{nombrebandeja}
    if ($mensajes.data('etiquetas-conectado')) {
      return;
    }

    $mensajes.data('etiquetas-conectado', true);
    $mensajes.on('click', '.tag-list .mail-tag', (event) => {
      this.seleccionar($(event.currentTarget));
    });
  }

  // Cuando recarga la página busca las etiquetas que están filtradas y las
  // las marca en la lista de etiquetas
  refrescarActivas() {
    const tags = $('#mensajes .tag-list .mail-tag');
    // No hay nube de tags, ignoramos. Esto por ejemplo se da en la edición de mensajes
    if (!tags.length) {
      return;
    }
    const etiquetas = $('#etiquetas-buscar-mensajes').val().split(',');
    tags.removeClass('active');

    // Foreach no funciona con estos tags de jquery , lo dejo como estaba con lodash
    each(tags, (el) => {
      const tag = $(el);
      const label = tag.find('.tag-label').text().trim();
      if (includes(etiquetas, label)) {
        tag.addClass('active');
      }
    });
  }

  cargarBotonEtiquetar() {
    new Cifra.Components.ModalHtml({
      el: '#boton-etiquetar',
      urlParams: function geturlParams() {
        const $boton = $('#boton-etiquetar');

        let ids = [];
        const idMensaje = $boton.data('mensajeId');
        if (!isBlank(idMensaje)) {
          ids.push(idMensaje);
        } else {
          // Listado de mensajes
          const $checks = $('#mensajes .table-mail .check-mail input:checked');
          if ($checks.length) {
            ids = map($checks, (check) => $(check).val());
          }
        }

        return { ids };
      },
    }).on('form:success', (data, _status, _xhr) => {
      const $boton = $('#boton-etiquetar');

      const idMensaje = $boton.data('mensajeId');

      // Actualizamos la nube de etiquetas
      if (data.etiquetas_cloud) {
        $('#mensajes .tag-list').replaceWith(data.etiquetas_cloud);
      }

      if (data.etiquetas_mensaje) {
        $(`#tags-${idMensaje}`).html(data.etiquetas_mensaje);
      }

      // Listado: Lanzamos la búsqueda par que recargue la página actual
      const $form = $('.form-buscar-mensajes');
      const action = $form.attr('action');
      $form.attr('action', `${action}?preserve_page=true`);
      $form.submit();
      $form.attr('action', action);
    });
  }

  // (Des)Marca una etiqueta y ejecuta la búsqueda
  seleccionar(tag) {
    tag.toggleClass('active');
    const taglist = tag.closest('.tag-list');
    const tags = map(taglist.find('.mail-tag.active'), (ctag) => ($(ctag).text()));
    const valor = tags.join(',');
    const $input = $('#etiquetas-buscar-mensajes');
    $input.val(valor);
    $input.closest('form').submit();
  }
}
